import React from 'react';
import classnames from 'classnames';

import Profile from 'shared/components/Profile';

import styles from './styles.module.scss';

class ProfileDropDown extends React.Component {
  render() {
    return (
      <div
        className={classnames(styles.profileDropDown, {
          [styles.isOpen]: this.props.isOpen
        })}>
        <Profile
          closeAction={this.props.closeHandler}
          notificationAlertCount={this.props.notificationAlertCount}
        />
      </div>
    );
  }
}

export default ProfileDropDown;
